import { useEffect, useState } from "react";

type BuildInfo = {
  frontendBuiltAt: string | null;
  backendDeployedAt: string | null;
  backendCommit: string | null;
  // when the backend process started - all there is under `npm run dev`, which has no build-info.json
  backendStartedAt: string | null;
  // true under the Vite dev server: frontendBuiltAt is then the dev server's start (vite.config.ts)
  isDevServer: boolean;
  loading: boolean;
};

export function useBuildInfo(): BuildInfo {
  const [backendDeployedAt, setBackendDeployedAt] = useState<string | null>(null);
  const [backendCommit, setBackendCommit] = useState<string | null>(null);
  const [backendStartedAt, setBackendStartedAt] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    // Plain fetch, not useApi()'s fetchApi - /version is deliberately unauthenticated, so
    // this doesn't wait on (or throw on) an unresolved MSAL access token.
    fetch(`${import.meta.env.VITE_API_URL}/version`)
      .then((res) => (res.ok ? res.json() : Promise.reject(res.statusText)))
      .then((data) => {
        if (cancelled) return;
        setBackendDeployedAt(data?.deployedAt ?? null);
        setBackendCommit(data?.commit ?? null);
        setBackendStartedAt(data?.startedAt ?? null);
      })
      .catch(() => {
        // backend unreachable / not yet deployed - the page shows "unknown"
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    frontendBuiltAt: import.meta.env.VITE_BUILD_TIME ?? null,
    backendDeployedAt,
    backendCommit,
    backendStartedAt,
    isDevServer: import.meta.env.DEV,
    loading,
  };
}
